import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

function convertToLocalTime(time: dayjs.ConfigType) {
    if (!time) return null;
    return dayjs.utc(time).local().format('YYYY-MM-DD HH:mm');
}

function convertToUTC(time: dayjs.ConfigType) {
    if (!time) return null;
    return dayjs(time).utc().format('YYYY-MM-DDTHH:mm:ss+00:00');
}

function convertToSecond(value: number, unit: string) {
    switch (unit) {
        case 'second':
            return value;
        case 'minute':
            return value * 60;
        case 'hour':
            return value * 60 * 60;
        case 'day':
            return value * 60 * 60 * 24;
        default:
            return value;
    }
}

function secondToTime(value: number) {
    const unit = 'second';
    if (value % (60 * 60 * 24) === 0) {
        return { value: value / 60 / 60 / 24, unit: 'day' };
    }
    if (value % (60 * 60) === 0) {
        return { value: value / 60 / 60, unit: 'hour' };
    }
    if (value % 60 === 0) {
        return { value: value / 60, unit: 'minute' };
    }
    return { value, unit };
}

function convertToCelsius(value: number, unit: string) {
    switch (unit) {
        case 'celsius':
            return value;
        case 'fahrenheit':
            return ((value - 32) * 5) / 9;
        default:
            return value;
    }
}

function convertTemperature(value: any, unit: string) {
    if (value === undefined || value === null || value === '') return value;

    switch (unit) {
        case 'celsius':
            return value;
        case 'fahrenheit':
            return (value * 9) / 5 + 32;
        default:
            return value;
    }
}

function checkThreshold(dataList: any[], threshold: any, interval: number) {
    if (!dataList || !threshold) return true;
    const { lower_limit, upper_limit, time_limit, type } = threshold;
    let abnormalCount = 0;

    for (const item of dataList) {
        const { temperature } = item;
        const tempInRange = temperature >= lower_limit && temperature <= upper_limit;
        if (!tempInRange) {
            abnormalCount++;
        } else if (type === 'continuous') {
            abnormalCount = 0; // Reset count if within range
        }
        if (abnormalCount * interval >= time_limit) {
            return false; // Threshold exceeded
        }
    }

    return true;
}

export {
    convertToLocalTime,
    convertToUTC,
    convertToSecond,
    secondToTime,
    convertToCelsius,
    convertTemperature,
    checkThreshold,
};
